import CrmUsers from "./CrmUsers";
// import React from 'react';
import Popover from "@material-ui/core/Popover";
import axios from "axios";
import Button from "@material-ui/core/Button";
// import SlidingPane from 'react-sliding-pane';
import Drawer from "@mui/material/Drawer";
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { fade, lighten, makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";

import Tooltip from "@material-ui/core/Tooltip";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
//import AccountCircle from '@material-ui/icons/AccountCircle';
import IconSearchRounded from "@material-ui/icons/SearchRounded";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import { de } from "date-fns/locale";
import { alignProperty } from "@mui/material/styles/cssUtils";
// import AspenMessages from './AspenMessages';

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props: any) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event: any) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event: any) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event: any) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event: any) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

//function descendingComparator(a, b, orderBy: any) {
function descendingComparator(a: any, b: any, orderBy: any) {
  //alert(a[orderBy]);
  //console.log("orderBy:" + orderBy);
  var x = a[orderBy];
  var y = b[orderBy];
  //console.log("orderBy: " + orderBy );

  if (orderBy.toLowerCase() == "dealername") {
    //console.log("123orderBy:" );
    x = x.toLowerCase();
    y = y.toLowerCase();
    //console.log("456orderBy:" );
    //console.log("123orderBy:" + orderBy + " : " + x );
  }
  if (a[orderBy] == null) {
    if (orderBy == "dateLastUsed") {
      x = "01/01/2020";
    }
  }
  if (b[orderBy] == null) {
    if (orderBy == "dateLastUsed") {
      y = "01/01/2020";
    }
  }

  // if (b[orderBy] < a[orderBy]) {
  //     return -1;
  // }
  // if (b[orderBy] > a[orderBy]) {
  //     return 1;
  // }
  if (y < x) {
    return -1;
  }
  if (y > x) {
    return 1;
  }
  return 0;
}

function getComparator(order: any, orderBy: any) {
  return order === "desc"
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function stableSort(array: any, comparator: any) {
  const stabilizedThis = array.map((el: any, index: any) => [el, index]);
  stabilizedThis.sort((a: any, b: any) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el: any) => el[0]);
}

const headCells = [
  {
    id: "dealerId",
    numeric: false,
    disablePadding: false,
    label: "DealerId (Location)",
  },
  {
    id: "companyDealerId",
    numeric: true,
    disablePadding: false,
    label: "CompanyId",
  },
  { id: "dealerName", numeric: false, disablePadding: false, label: "Name" },
  { id: "address", numeric: false, disablePadding: false, label: "Address" },
  { id: "phone", numeric: false, disablePadding: false, label: "Phone" },
  { id: "email", numeric: false, disablePadding: false, label: "Email" },
  { id: "customers", numeric: true, disablePadding: false, label: "Customers" },
  { id: "invoices", numeric: true, disablePadding: false, label: "Invoices" },
  { id: "users", numeric: true, disablePadding: false, label: "Users" },
  {
    id: "lastUpdated",
    numeric: false,
    disablePadding: false,
    label: "Last Update",
  },
];

function EnhancedTableHead(props: any) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property: any) => (event: any) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          />
        </TableCell> */}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props: any) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <div></div>
    // <Toolbar
    //   className={clsx(classes.root, {
    //     [classes.highlight]: numSelected > 0,
    //   })}
    // >
    //   {numSelected > 0 ? (
    //     <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
    //       {numSelected} selected
    //     </Typography>
    //   ) : (
    //     <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
    //       Nutrition
    //     </Typography>
    //   )}

    //   {numSelected > 0 ? (
    //     <Tooltip title="Delete">
    //       <IconButton aria-label="delete">
    //         {/* <DeleteIcon /> */}
    //       </IconButton>
    //     </Tooltip>
    //   ) : (
    //     <Tooltip title="Filter list">
    //       <IconButton aria-label="filter list">
    //         {/* <FilterListIcon /> */}
    //       </IconButton>
    //     </Tooltip>
    //   )}
    // </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  inActiveDealer: {
    color: "red",
    textDecoration: "line-through",
  },

  typography: {
    padding: theme.spacing(2),
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    "& .MuiTableCell-root": {
      paddingLeft: "10px",
      paddingRight: "10px",
    },
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    color: "white",
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    fontWeight: "bolder",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

const DatawarehouseDealerDetail = (props: any) => {
  // alert('EnhancedTable');

  // export default function EnhancedTable(props) {
  //const { dealerId } = props.id;
  //  console.error("eeeeeee");
  //  console.error(props);
  //  alert(props.id);
  //  console.error(ppppppp);
  //alert(props.DealerId);
  const classes = useStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(200);
  const [data, SetData] = useState([] as any);
  const [dataImport, SetDataImport] = useState([] as any);
  const [searchdata, SetSearchdata] = useState("");
  const [loading, setLoading] = useState("Please wait.. gathering data");
  const [isPaneOpen, SetIsPaneOpen] = React.useState(false);
  const [childMessages, SetChildMessages] = useState([] as any);
  const [showExportButton, SetShowExportButton] = React.useState(false);
  const [showRefreshButton, SetShowRefreshButton] = React.useState(false);
  const [importStatus, SetImportStatus] = useState("Not in Target CRM");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [openUserDrawer, SetOpenUserDrawer] = useState(false);
  const [NameClickCount, SetNameClickCount] = React.useState(0);
  const [DealerIdClickCount, SetDealerIdClickCount] = React.useState(0);
  const [currentRow, SetCurrentRow] = useState([] as any);
  const [showAllRefeeds, SetShowAllRefeeds] = useState(false);
  const [showReFeedCode, SetShowReFeedCode] = useState(false);

  const [openEdit, setOpenEdit] = React.useState(false);
  const [anchorElEdit, setAnchorElEdit] = React.useState(null);

  const [openMoreInfo, setOpenMoreInfo] = React.useState(false);
  const [anchorMoreInfo, setAnchorMoreInfo] = React.useState(null);

  // const [dealerName, SetDealerName] = useState([]);
  // const [editDealerID, SetEditDealerID] = useState(0);
  // const [currentLocationRow, SetCurrentLocationRow] = useState([]);

  let rowEventHandled = 0;

  function GetData() {
    return data.filter(filterRow);
  }
  function filterRow(element: any, index: any, array: any) {
    if (data.length > 0) {
      var obj1 = data[0];
      var keys = Object.keys(obj1);
      let i = 0;
      for (i = 0; i < keys.length; i++) {
        let cellValue = String(element[keys[i]]);
        if (cellValue.toLowerCase().includes(searchdata.toLowerCase())) {
          return true;
        }
      }
    }
    return false;

    // if (myName === '') { return true };
    // let name: string = element['name'];
    // let address: string = element['address'];
    // if (name.toLowerCase().includes(myName.toLowerCase())) { return true; }
    // if (address.toLowerCase().includes(myName.toLowerCase())) { return true; }
    // return false;
  }

  function closeModal() {
    SetIsPaneOpen(false);
  }

  // useEffect(() => {
  //     if(NameClickCount>3){
  //         alert(NameClickCount);
  //     }
  // }, [NameClickCount]);
  function GetDomainUser() {
    let name = localStorage.getItem("username");
    if (name == null) {
      name = "";
    }
    return name;
  }

  async function RefeedData(row: any, feedId: number, feedtype: string) {
    if (
      window.confirm(
        `Are you [${GetDomainUser()}] sure you want to refeed all ${feedtype}?`
      ) != true
    )
      return;

    const body = {
      query: "DataReFeed",
      queryBody: {
        domainUser: GetDomainUser(),
        dealerId: props.currentRow.dealerId,
        feedId: feedId,
      },
    };
    const response = await fetchData(body);
    if (response.data == null) {
      console.log(response.data);
      setOpenEdit(false);
    }
  }

  function HandleNameClick(e: any, row: any) {
    SetCurrentRow(row);
    SetNameClickCount(NameClickCount + 1);
    if (NameClickCount > 3) {
      if (row.dmsType == 12) {
        alert("Refeed not allowed for this DMS");
        return;
      }
      setAnchorElEdit(e.currentTarget);
      setOpenEdit(true);
      SetNameClickCount(0);
    }
  }

  function HandleDealerIdClick(e: any) {
    SetDealerIdClickCount(DealerIdClickCount + 1);
    if (DealerIdClickCount > 10) {
      SetDealerIdClickCount(0);
      // SetShowAllRefeeds(true);
      SetShowReFeedCode(true);
      // let userCode = prompt("Please enter the code:");
      // if (userCode == "r@nger") {
      //   setAnchorElEdit(e.currentTarget);
      //   setOpenEdit(true);
      //   SetShowAllRefeeds(true);
      // }
      // // setAnchorElEdit(e.currentTarget);
      // // setOpenEdit(true);
      // // SetNameClickCount(0);
    }
  }

  useEffect(() => {
    GetDealerData();
  }, []);

  async function GetDealerData() {
    const body = {
      query: "DealerDetail",
      queryBody: { DealerId: props.DealerId },
    };
    const response = await fetchData(body);
    if (response.data != null) {
      console.log(response.data);
      SetData(response.data);
      setLoading("");
      SetIsPaneOpen(true);
      GetDataImportStatus();
    }
  }

  async function fetchData(body: any) {
    try {
      var token = "Y1N5c3RlbXM6U0hyaXNqMENuaGxw";
      const response = await axios.post(
        "https://csidealerProd.azurewebsites.net/api/Query",
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response;
    } catch (error) {
      throw error; // optionally handle error
    }
  }

  async function GetDataImportStatus() {
    const body = {
      query: "TargetCrm.TargetImportStatus",
      queryBody: { DmsDealerId: props.dmsDealerId },
    };
    const response = await fetchData(body);
    console.log(response);
    SetDataImport(response.data[0]);
    SetShowExportButton(true);
    if (response.data != null && response.data.length > 0) {
      SetShowExportButton(response.data[0]["dealerCount"] == 0 ? true : false);
      var xdate = new Date(response.data[0]["dateQueued"]);
      if (response.data[0]["dateStarted"] != null) {
        xdate = new Date(response.data[0]["dateStarted"]);
      }
      if (response.data[0]["dateEnded"] != null) {
        xdate = new Date(response.data[0]["dateEnded"]);
      }

      var xdate2 = xdate.toLocaleString();
      var xdate3 = new Date(xdate2 + " UTC");
      SetImportStatus(
        response.data[0]["status"] + " " + xdate3.toLocaleString(),
      );
      SetShowRefreshButton(
        response.data[0]["dateEnded"] == null ? true : false,
      );
    }
  }

  const handleCloseAdmin = () => {
    setAnchorEl(null);
  };

  function ValidateRefeedCode() {
    let elPassword: any = document.getElementById("inputRefeedCode");
    if (elPassword == null) return;
    let refeedCode: string = elPassword.value;
    if (refeedCode == "r@nger") {
      SetShowReFeedCode(false);
      SetShowAllRefeeds(true);
      setOpenEdit(true);
    }
  }

  function ValidatePassword() {
    let elLogin: any = document.getElementById("inputLogin");
    let elPassword: any = document.getElementById("inputPassword");
    if (elLogin == null || elPassword == null) {
      return;
    }
    let validPassword = false;
    let userName: string = elLogin.value.toLowerCase();
    // switch (elLogin.value.toLowerCase()) {
    switch (userName) {
      case "karticghosh":
        if (elPassword.value == "karticGhosh-2008") {
          validPassword = true;
          break;
        }
        break;
      case "timburman":
        if (elPassword.value == "timBurman-2021") {
          validPassword = true;
          break;
        }

        // case 'karticGhosh2008':
        // validPassword = true;
        break;
    }

    // if (el.value != 'admin2') {
    //     alert('Invalid password. Please try again');
    //     return;
    // }
    //alert(validPassword);
    if (validPassword) {
      setAnchorEl(null);
      ExportData(elLogin.value);
    } else {
      alert("Invalid login or password");
    }
    // SetPassword(el.value);
    // SetEditDealerID(dealerID);
    // setAnchorEl(null);
    // sessionStorage.setItem('adminPassword', el.value);
  }

  function ExportData(passcode: any) {
    //let url="http://localhost:7071/api/DataImportQueue/" + props.dmsDealerId + "/" + passcode;
    //let url="https://azurefunctionkg.azurewebsites.net/api/DataImportQueue/{dmsDealerId}/{userName}?code=v/iwgYfH3JoOzDv/OgfmtW0Pu8Azpe4lI5FTcdrN/o4pt4uRnh5h3g=="
    let url =
      "https://azurefunctionkg.azurewebsites.net/api/DataImportQueue/" +
      props.dmsDealerId +
      "/" +
      passcode +
      "?code=gJP2NYgT/ht9LWhg8PRIpXWfF6h8xhBrtx9kGL80lydAtI05ZFJUCA==";
    //alert(url);
    axios.all([axios.get(url)]).then(
      axios.spread((obj1) => {
        //alert(obj1.data);
        //SetImportStatus(obj1.data);
        //SetShowExportButton(false);
        GetDataImportStatus();
        // SetData(obj1.data);
        // SetDataImport(obj2.data[0]);
        // setLoading('');
        // SetIsPaneOpen(true);
        // SetShowExportButton(obj2.data[0]["dealerCount"] == 0 ? true : false);
      }),
    );
  }

  function buttonExportClick(e: any) {
    setAnchorEl(e.currentTarget);
  }

  function LastUpdateDoubleClick(e: any, row: any) {
    SetCurrentRow(row);
    setAnchorMoreInfo(e.currentTarget);
    setOpenMoreInfo(true);
  }

  function MoreInfoData() {
    let jsonString = currentRow.dmsInfo;
    let parsed;
    try {
      parsed = JSON.parse(jsonString);
      let jsonCompany = parsed.CompanyInfo;
      if (jsonCompany != null && jsonCompany.trim().length > 0) {
        parsed.CompanyInfo = JSON.parse(jsonCompany);
      }
    } catch (e) {
      return <span></span>;
    }
    return <pre>{JSON.stringify(parsed, null, 2)}</pre>;
  }

  const handleRequestSort = (event: any, property: any) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: any) => {
    // if (event.target.checked) {
    //     alert('handleSelectAllClick');
    //     const newSelecteds = data.map((n) => n.name);
    //     setSelected(newSelecteds);
    //     return;
    // }
    // setSelected([]);
  };

  const handleRowClick = (event: any, name: any) => {
    // const selectedIndex = selected.indexOf(name);
    // let newSelected = [];
    // if (selectedIndex === -1) {
    //     newSelected = newSelected.concat(selected, name);
    // } else if (selectedIndex === 0) {
    //     newSelected = newSelected.concat(selected.slice(1));
    // } else if (selectedIndex === selected.length - 1) {
    //     newSelected = newSelected.concat(selected.slice(0, -1));
    // } else if (selectedIndex > 0) {
    //     newSelected = newSelected.concat(
    //         selected.slice(0, selectedIndex),
    //         selected.slice(selectedIndex + 1),
    //     );
    // }
    // setSelected(newSelected);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event: any) => {
    setDense(event.target.checked);
  };

  const handleDealerRowClick = (currentRow: any) => {
    // alert(currentRow.aspenLocationId);
    // const _setChildDealerSurvey = <DealerSurveys key={new Date().getTime()} id={id} dealer={FindDealerName(id)} />;
    // let _AspenMessages = <AspenMessages key={new Date().getTime()} locationId={currentRow.aspenLocationId} currentRow={currentRow} />;
    // SetChildMessages(_AspenMessages)
  };

  function CloseUserDrawer() {
    SetOpenUserDrawer(false);
  }

  function GetLocationName(row: any, name: any): any {
    var location = GetDmsInfo(row, "locationCode");
    if (location != "") {
      name = name + " (" + location + ")";
    }
    var GSTRegNo = GetDmsInfo(row, "GSTRegNo");
    if (GSTRegNo != "") {
      name = name + " (" + GSTRegNo + ")";
    }
    var branchNumber = GetDmsInfo(row, "Branch_Number");
    console.log("branchNumber: " + branchNumber);
    if (branchNumber != "") {
      name = name + " (" + branchNumber + ")";
      console.log("dealerNumber-1: " + branchNumber);
    }
    return name;
  }
  function GetDmsInfo(row: any, property: any): any {
    var propertyValue = "";
    try {
      var dmsInfo = row.dmsInfo;
      var dms = JSON.parse(dmsInfo);
      // if (dms[property] == null) return;
      propertyValue = dms[property];
      if (propertyValue === null || propertyValue === undefined) {
        propertyValue = "";
      }

      // var companyInfo = dms.CompanyInfo;
      // if (companyInfo == null) return "";
      // var company = JSON.parse(companyInfo);
      // if (company != null || company.trim().length > 0)
      //   companyName = company.Name;
    } catch (error) {
      //return "error-" + property;
    } finally {
      return propertyValue;
    }
  }

  function GetDmsRoot(row: any): any {
    try {
      const jsonString = row?.dmsInfo;
      if (jsonString == null || String(jsonString).trim().length === 0)
        return null;
      const parsed = JSON.parse(jsonString);
      return parsed?.DmsInfo ?? parsed;
    } catch (e) {
      return null;
    }
  }

  function GetCompanyInfo(row: any): any {
    try {
      const dmsRoot = GetDmsRoot(row);
      if (dmsRoot == null) return null;
      let companyInfo = dmsRoot?.CompanyInfo;
      if (companyInfo == null) return null;

      if (typeof companyInfo === "string") {
        if (companyInfo.trim().length === 0) return null;
        companyInfo = JSON.parse(companyInfo);
      }

      return companyInfo;
    } catch (e) {
      return null;
    }
  }

  function IsPrimaryLocation(row: any): boolean {
    const dmsRoot = GetDmsRoot(row);
    if (dmsRoot == null) return false;
    const isPrimary = dmsRoot.IsPrimary;
    return isPrimary === 1 || isPrimary === "1" || isPrimary === true;
  }

  function GetMainBranchIdValue(row: any): string {
    const dmsRoot = GetDmsRoot(row);
    if (dmsRoot == null) return "";
    const v = dmsRoot.main_branch_id;
    if (v == null) return "";
    return String(v).trim();
  }

  function GetEffectiveMainBranchId(): string {
    let mainBranchId = GetMainBranchIdValue(props.currentRow);
    if (mainBranchId.length > 0) return mainBranchId;
    if (Array.isArray(data)) {
      for (const r of data) {
        const v = GetMainBranchIdValue(r);
        if (v.length > 0) return v;
      }
    }
    return "";
  }

  function IsRowPrimary(row: any): boolean {
    if (IsPrimaryLocation(row)) return true;
    const mainBranchId = GetEffectiveMainBranchId();
    if (mainBranchId.length === 0) return false;
    if (row?.dmsLocationId == null) return false;
    return String(row.dmsLocationId).trim() === mainBranchId;
  }

  function GetCompanyInfoName(row: any): string {
    const companyInfo = GetCompanyInfo(row);
    const companyName = companyInfo?.Name;
    if (companyName == null) return "";
    return String(companyName).trim();
  }

  function GetCompanyInfoAddress(row: any): string {
    const companyInfo = GetCompanyInfo(row);
    if (companyInfo == null) return "";
    const parts = [
      companyInfo.Address,
      companyInfo.City,
      companyInfo.State,
      companyInfo.Zip,
    ]
      .filter((v) => v != null && String(v).trim().length > 0)
      .map((v) => String(v).trim());
    return parts.join(", ");
  }

  function GetCompanyName() {
    // var companyName = GetDealerNumber() + props.currentRow.dealerName;
    var companyName = props.currentRow.dealerName;
    try {
      const dataCompany = data.filter((item: any) => {
        if (item.dealerId == item.companyDealerId) {
          return item;
        }
      });

      if (dataCompany.length > 0) {
        companyName = companyName + " " + dataCompany[0].dmsDealerId;
        if (
          dataCompany[0].dealerNumber != null &&
          dataCompany[0].dealerNumber.trim().length > 0
        ) {
          companyName += " (" + dataCompany[0].dealerNumber + ")";
        }
        // var dmsInfo = dataCompany[0].dmsInfo;
        // var dms = JSON.parse(dmsInfo);
        // if (dms.CompanyInfo == null) return;
        // var companyInfo = dms.CompanyInfo;
        // if (companyInfo == null) return "";
        // var company = JSON.parse(companyInfo);
        // if (company != null || company.trim().length > 0)
        //   companyName = company.Name;
      }
    } catch (error) {
    } finally {
      return companyName;
    }
  }

  function GetDealerNumber() {
    var dealerNumber = "";
    try {
      const dataCompany = data.filter((item: any) => {
        if (item.dealerId == item.companyDealerId) {
          return item;
        }
      });

      if (dataCompany.length > 0) {
        var _dealerNumber = dataCompany[0].dealerNumber;
        if (
          dealerNumber != null &&
          _dealerNumber != undefined &&
          _dealerNumber.trim().length > 0
        )
          dealerNumber = _dealerNumber + "-";
      }
    } catch (error) {
    } finally {
      return dealerNumber;
    }
  }

  function GetDealerId(row: any) {
    var dealerId = `${row.dealerId} (${row.dmsDealerId}-${row.dmsLocationId})`;
    if (row.dealerId == row.companyDealerId) dealerId = "\u2713 " + dealerId;
    return dealerId;
  }

  function GetMainBranchId(row: any) {
    try {
      var mainBranchId = GetDmsInfo(row, "main_branch_id");
      if (mainBranchId != null && mainBranchId.trim().length > 0) {
        return ` (Main Location: ${mainBranchId})`;
      }
    } catch (error) {}
  }

  function TolocalTime(utcDate: any) {
    if (utcDate == null) return "";
    const localDateTime = new Date(utcDate).toLocaleString();
    return localDateTime;
  }

  // const isSelected = (name :any) => selected.indexOf(name) !== -1;

  // const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
  const emptyRows = 0;

  return (
    <div
      style={{ position: "relative", border: "0px solid red" }}
      className={classes.root}
    >
      {/* <SlidingPane
                width="80%"
                className='some-custom-class'
                overlayClassName='some-custom-overlay-class'
                isOpen={isPaneOpen}
                title={"Dealer detail for: " + props.currentRow.dealerName + ' (' + props.currentRow.dmsDealerId + ')'}
                // subtitle={"Location: " + props.currentRow.locationName + ' (+' + props.currentRow.twilioPhoneNumber + ')'}
                onRequestClose={closeModal}> */}
      <Drawer
        PaperProps={{ style: { width: "auto", minWidth: "10%" } }}
        anchor="right"
        open={isPaneOpen}
        onClose={closeModal}
        variant={"temporary"}
      >
        {(() => {
          const companyName = GetCompanyInfoName(props.currentRow);
          const primary =
            companyName.length > 0 ? companyName : GetCompanyName();
          const companyAddress = GetCompanyInfoAddress(props.currentRow);

          let pillText = "";
          try {
            const dataCompany = data.filter(
              (item: any) => item.dealerId == item.companyDealerId,
            );
            if (dataCompany.length > 0) {
              pillText = String(dataCompany[0].dmsDealerId ?? "");
              const dealerNumber = dataCompany[0].dealerNumber;
              if (
                dealerNumber != null &&
                String(dealerNumber).trim().length > 0
              ) {
                pillText += " (" + dealerNumber + ")";
              }
            }
          } catch (e) {}

          return (
            <div
              style={{
                padding: "13px 5px",
                backgroundColor: "#F2F3F4",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  flexWrap: "wrap",
                  fontWeight: "bold",
                  fontSize: "large",
                }}
              >
                <span>{primary}</span>
                {pillText.length > 0 && (
                  <span
                    style={{
                      display: "inline-block",
                      padding: "2px 10px",
                      border: "1px solid #d0d7de",
                      borderRadius: "12px",
                      backgroundColor: "#ffffff",
                      color: "#24292f",
                      fontSize: "0.85rem",
                      fontWeight: "normal",
                      lineHeight: 1.4,
                    }}
                    title={pillText}
                  >
                    {pillText}
                  </span>
                )}
              </div>
              {companyAddress.length > 0 && (
                <div
                  style={{
                    marginTop: "4px",
                    color: "rgba(0,0,0,0.6)",
                    fontSize: "0.85rem",
                    fontWeight: "normal",
                  }}
                >
                  {companyAddress}
                </div>
              )}
            </div>
          );
        })()}

        <div
          style={{ position: "relative", border: "0px solid red" }}
          className={classes.root}
        >
          {/* <SlidingPane
                className='some-custom-class'
                overlayClassName='some-custom-overlay-class'
                isOpen={isPaneOpen}
                title={props.dealer}
                subtitle="Survey's In last 30 days"
                onRequestClose={closeModal}> */}

          <div style={loading == "" ? { display: "none" } : {}}>
            <h1>{loading}</h1>
          </div>
          {/* {searchdata} */}
          {/* <Paper xclassName={classes.paper} xstyle={{ width:1175, marginTop:10  }}></Paper> */}
          <Paper style={{ display: "table" }}>
            <div style={{ position: "fixed", top: "0px", right: "10px" }}>
              <table>
                <tr>
                  <td>
                    <div style={{ display: showExportButton ? "none" : "" }}>
                      <table>
                        <tr>
                          <td>
                            <Button
                              variant="contained"
                              color="primary"
                              disableElevation
                              onClick={GetDataImportStatus}
                              style={{
                                display: showRefreshButton ? "" : "none",
                              }}
                            >
                              Refresh
                            </Button>
                          </td>
                          <td>
                            <div
                              style={{
                                borderRadius: "5px",
                                padding: "10px 15px",
                                backgroundColor: "green",
                                color: "white",
                              }}
                            >
                              {importStatus}&nbsp;&nbsp;
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{ position: "fixed", right: "15px", top: "5px" }}
                      className={classes.search}
                    >
                      <span style={{ display: showExportButton ? "" : "none" }}>
                        {/* </span>/ */}
                        {/* <Button id="buttonExportData" variant="contained" color="primary" disableElevation onClick={buttonExportClick} ></Button> */}
                        <Button
                          id="buttonExportData"
                          variant="contained"
                          color="primary"
                          disableElevation
                          onClick={(e) => buttonExportClick(e)}
                        >
                          Export data to Target CRM
                        </Button>
                      </span>
                    </div>
                  </td>
                  <td></td>
                </tr>
              </table>
            </div>

            <EnhancedTableToolbar numSelected={selected.length} />
            <TableContainer>
              <Table
                className={"myTable2 " + classes.table}
                aria-labelledby="tableTitle"
                size={dense ? "small" : "medium"}
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={GetData().length}
                />
                <TableBody>
                  {
                    //    stableSort(rows, getComparator(order, orderBy))
                    stableSort(GetData(), getComparator(order, orderBy))
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      //data
                      .map((row: any, index: any) => {
                        // console.warn('ktest');
                        // console.log(dataImport);
                        // console.log(dataImport['dealerCount']);
                        // console.warn('ktest1');
                        // const isItemSelected = isSelected(row.dealerId);
                        let inactive = 0;
                        let name = row.dealerName;
                        if (row.isActive == false) {
                          name = name + " [INACTIVE] ";
                          inactive = 1;
                        }
                        // if (row.isDealerLocation == false) { name = name + " [ISDEALERLOCATION=0]"; inactive = 1 };
                        let xclass = "";
                        if (inactive == 1) xclass = classes.inActiveDealer;

                        const labelId = `enhanced-table-checkbox-${index}`;
                        let address =
                          row.address +
                          ", " +
                          row.city +
                          ", " +
                          row.stateOrProvince +
                          " " +
                          row.zipPostal;
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            // aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.name}
                            // selected={isItemSelected}
                          >
                            <TableCell
                              align="right"
                              // onClick={(event) => {
                              //   HandleDealerIdClick(event, row);
                              // }}
                            >
                              {IsRowPrimary(row) && (
                                <span
                                  style={{
                                    color: "#f5b301",
                                    marginRight: "4px",
                                  }}
                                  title="Primary location"
                                >
                                  {"\u2605"}
                                </span>
                              )}
                              {GetDealerId(row)}

                              {/* {row.dealerId == row.companyDealerId ? "\u2713 " : ""}
                              {row.dealerId} */}
                            </TableCell>
                            <TableCell align="center">
                              {row.companyDealerId}
                            </TableCell>
                            {/* <TableCell>{row.dealerName}</TableCell> */}
                            <TableCell
                              className={xclass}
                              onClick={(event) => {
                                HandleNameClick(event, row);
                              }}
                            >
                              {GetLocationName(row, name)}
                              {(() => {
                                const companyName = GetCompanyInfoName(row);
                                if (companyName.length === 0) return null;
                                if (
                                  row?.dealerName != null &&
                                  String(row.dealerName).trim().toLowerCase() ===
                                    companyName.toLowerCase()
                                ) {
                                  return null;
                                }
                                return (
                                  <div
                                    style={{
                                      color: "rgba(0,0,0,0.45)",
                                      fontSize: "0.75rem",
                                      lineHeight: 1.2,
                                    }}
                                  >
                                    {companyName}
                                  </div>
                                );
                              })()}
                              {/* <br></br> */}
                              <span
                                style={{
                                  // padding: "13px 5px",
                                  //backgroundColor: "#F2F3F4",
                                  // fontWeight: "bold",
                                  // fontSize: "small",
                                  color: "silver",
                                }}
                              >
                                {GetMainBranchId(row)}
                              </span>
                            </TableCell>
                            {/* <TableCell>{row.isActive}</TableCell> */}
                            <TableCell>{address}</TableCell>
                            <TableCell>{row.phone}</TableCell>
                            <TableCell>{row.email}</TableCell>
                            <TableCell align="right">{row.customers}</TableCell>
                            <TableCell align="right">{row.invoices}</TableCell>
                            <TableCell align="right">
                              <span
                                style={{
                                  textDecoration: "underline",
                                  color: "blue",
                                  cursor: "pointer",
                                }}
                                onClick={(event) => {
                                  SetOpenUserDrawer(true);
                                }}
                              >
                                {row.users}
                              </span>
                            </TableCell>
                            <TableCell
                              onDoubleClick={(e) =>
                                LastUpdateDoubleClick(e, row)
                              }
                            >
                              {TolocalTime(row.lastUpdated)}
                            </TableCell>
                          </TableRow>
                        );
                      })
                  }
                  {emptyRows > 0 && (
                    <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {/* <TablePagination
                    rowsPerPageOptions={[10, 15, 20, 25, 30]}
                    component="div"
                    count={GetData().length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}

                /> */}
          </Paper>
          <div>{childMessages}</div>
          {/* </SlidingPane> */}
        </div>

        <Popover
          open={openMoreInfo}
          anchorEl={anchorMoreInfo}
          onClose={() => setOpenMoreInfo(false)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Typography
            className={classes.typography}
            style={{ backgroundColor: "AliceBlue" }}
          >
            <div>
              <MoreInfoData></MoreInfoData>
            </div>
          </Typography>
        </Popover>

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleCloseAdmin}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Typography
            className={classes.typography}
            style={{ backgroundColor: "AliceBlue" }}
          >
            <div>
              <table>
                <tr>
                  <td>Login</td>
                  <td>
                    <input
                      style={{ padding: "5px 10px" }}
                      autoFocus
                      id="inputLogin"
                      onKeyPress={(event) => {}}
                    ></input>
                  </td>
                </tr>
                <tr>
                  <td>Password&nbsp;</td>
                  <td>
                    <input
                      style={{ padding: "5px 10px" }}
                      type="password"
                      id="inputPassword"
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          ValidatePassword();
                        }
                      }}
                    ></input>
                    &nbsp;
                  </td>
                </tr>
              </table>
              <div style={{ textAlign: "center" }}>
                <Button
                  id="buttonExportData"
                  variant="contained"
                  color="secondary"
                  disableElevation
                  onClick={ValidatePassword}
                >
                  Get Data Now
                </Button>
              </div>
            </div>
            {/* Admin Password&nbsp; */}
          </Typography>
        </Popover>

        <Popover
          open={openEdit}
          anchorEl={anchorElEdit}
          // onClose={handleCloseAdmin}
          onClose={(event) => {
            setOpenEdit(false);
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Typography
            className={classes.typography}
            style={{ backgroundColor: "AliceBlue" }}
            onClick={(event) => {
              HandleDealerIdClick(event);
            }}
          >
            <div
              onClick={(event) => {
                HandleDealerIdClick(event);
              }}
            >
              <div style={{ width: "300px" }}>
                <div style={{ marginTop: "5px" }}>
                  <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    fullWidth
                    onClick={(event: any) => {
                      RefeedData(currentRow, 7, "Users");
                    }}
                  >
                    Refeed Users
                  </Button>
                </div>
                {showAllRefeeds && (
                  <div>
                    <div style={{ marginTop: "5px" }}>
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        fullWidth
                        onClick={(event: any) => {
                          RefeedData(currentRow, 4, "Customers");
                        }}
                      >
                        Refeed Customers
                      </Button>
                    </div>
                    <div style={{ marginTop: "5px" }}>
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        fullWidth
                        onClick={(event: any) => {
                          RefeedData(currentRow, 2, "Inventory Parts");
                        }}
                      >
                        Refeed Inventory Parts
                      </Button>
                    </div>
                    <div style={{ marginTop: "5px" }}>
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        fullWidth
                        onClick={(event: any) => {
                          RefeedData(currentRow, 14, "Inventory Models");
                        }}
                      >
                        Refeed Inventory Models
                      </Button>
                    </div>
                    <div style={{ marginTop: "5px" }}>
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        fullWidth
                        onClick={(event: any) => {
                          RefeedData(currentRow, 3, "Inventory Wholegoods");
                        }}
                      >
                        Refeed Inventory Wholegoods
                      </Button>
                    </div>
                    <div style={{ marginTop: "5px" }}>
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        fullWidth
                        disabled
                        onClick={(event: any) => {
                          RefeedData(currentRow, 6, "Invoices");
                        }}
                      >
                        Refeed Invoices
                      </Button>
                    </div>
                  </div>
                )}
              </div>
              {/* <a href="https://example.com" onClick={handleClick}>
                Click me
              </a> */}
              {showReFeedCode && (
                <div
                  style={{
                    marginTop: "20px",
                    border: "1px solid silver",
                    padding: "2px 5px",
                  }}
                >
                  <table>
                    <tr>
                      <td>Enter code</td>
                      <td>
                        <input
                          type="password"
                          autoComplete="off"
                          id="inputRefeedCode"
                        ></input>
                      </td>
                      <td style={{ paddingLeft: "10px" }}>
                        <Button
                          variant="contained"
                          onClick={(event: any) => {
                            ValidateRefeedCode();
                          }}
                        >
                          Okay
                        </Button>
                      </td>
                    </tr>
                  </table>
                </div>
              )}
            </div>
          </Typography>
        </Popover>
        <CrmUsers
          open={openUserDrawer}
          dealerId={props.DealerId}
          dmsDealerId={props.dmsDealerId}
          onClose={CloseUserDrawer}
          tag="datawarehouse"
        ></CrmUsers>
      </Drawer>
    </div>
  );
};
export default DatawarehouseDealerDetail;
